'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping from "./presto.types$-Grouping.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Grouping$() {
}
export { $c_Lpresto_types$Grouping$ as $c_Lpresto_types$Grouping$ };
$p = $c_Lpresto_types$Grouping$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Grouping$;
/** @constructor */
function $h_Lpresto_types$Grouping$() {
}
export { $h_Lpresto_types$Grouping$ as $h_Lpresto_types$Grouping$ };
$h_Lpresto_types$Grouping$.prototype = $p;
$p.l = (function() {
  return "Grouping";
});
$p.p0 = (function(x$0) {
  return new $j_presto$002etypes$0024$002dGrouping.$c_Lpresto_types$Grouping($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(2)), x$0.j(3), x$0.j(4), x$0.j(5));
});
var $d_Lpresto_types$Grouping$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Grouping$, "presto.types$Grouping$", ({
  a0d: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$Grouping$ as $d_Lpresto_types$Grouping$ };
var $n_Lpresto_types$Grouping$;
function $m_Lpresto_types$Grouping$() {
  if ((!$n_Lpresto_types$Grouping$)) {
    $n_Lpresto_types$Grouping$ = new $c_Lpresto_types$Grouping$();
  }
  return $n_Lpresto_types$Grouping$;
}
export { $m_Lpresto_types$Grouping$ as $m_Lpresto_types$Grouping$ };
//# sourceMappingURL=presto.types$-Grouping$.js.map
